import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";
import CgnButtonDropdown from "../toolbox/CgnButtonDropdown";
import CgnBadge from "../toolbox/CgnBadge";

class TransferStockGetList extends Component {
  state = {
    pageTitle: "Yetkili Stok Aktarım Listele",
    pageAddLink: "stok-aktarim-ekle",
    pageUpdateLink: "stok-aktarim-guncelle",
    pageDetailLink: "yetkili-stok-aktarim-detay",
    pageListLink: "yetkili-stok-aktarim-listele",
    breadcrumb: [{ text: "Stok Aktarım", link: "#" }],
    isLoading: false,
    isDeleted: false,
    status: false,
    productCountData: [],
    productItemCount: 0,
    locationName: "",
    guid: "",
    createdBy: "",
    alertErrorMessage: "",
    detail: false,
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var URLParam = "";
    var statusType = 1; // 1 aktif ve pasiflerin ikisinide getirmesi için
    URLParam = "/transferStocks/getlistcompleted/" + statusType;
    await axios
      .get(URL + URLParam, config)
      .then((response) => {
        this.setState({
          productCountData: response.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  }

  handleDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.deleteItem(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };


  async stockTransfer(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/machineStocks/addstock/" + guid;
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        confirmAlert({
          title: CgnMessage.alertSuccessTitle,
          message: CgnMessage.stockTransferSuccessMessage,
          buttons: [
            {
              label: CgnMessage.closeButton,
              onClick: () => {
                window.location.reload();
              }
            },
          ],
        });
      })
      .catch((error) => {
        confirmAlert({
          title: CgnMessage.alertErrorTitle,
          message: error.response.data,
          buttons: [
            {
              label: CgnMessage.closeButton,
              onClick: () => {
                this.setState({
                  isLoading: false,
                });
              }
            },
          ],
        });
      });
  };

  async deleteItem(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/transferStocks/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        confirmAlert({
          title: CgnMessage.alertSuccessTitle,
          message: CgnMessage.deleteSuccessMessage,
          buttons: [
            {
              label: CgnMessage.closeButton,
              onClick: () => {
                  window.location.reload();
              }
            },
          ],
        });
      })
      .catch((error) => {
        confirmAlert({
          title: CgnMessage.alertErrorTitle,
          message: error.response.data,
          buttons: [
            {
              label: CgnMessage.closeButton,
              onClick: () => {
                this.setState({
                  isLoading: false,
                });
              }
            },
          ],
        });
      });
  }

  thStyle = {
    width: "50px",
  };

  thStyle2 = {
    width: "120px",
  };

  tdStyle = {
    width: "400px",
  };

  render() {
    return (
      <>
        {this.state.detail === false && (
          <ContentTop
            breadcrumb={this.state.breadcrumb}
            title={this.state.pageTitle}
            listLink={"/" + this.state.pageListLink}
          />
        )}
        <Row className="productCountGetList" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              <CgnDatatable
                data={this.state.productCountData}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Stok Aktarım Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      return (
                        <Table className="table table-responsive ">
                          <tbody>
                            <tr>
                              <th style={this.thStyle}>Depo</th>
                              {/* <th className="colon">:</th> */}
                              <td style={this.tdStyle}>
                                {row.locationName}
                              </td>
                              <th style={this.thStyle2}>Aktarılan Depo</th>
                              {/* <th className="colon">:</th> */}
                              <td>
                                {row.transferLocationName}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      );
                    },
                  },
                  {
                    selector: "processStatus",
                    width: "150px",
                    padding: "0px",
                    sortable: false,
                    cell: (row) => {
                      if (!row.processStatus || row.processStatus === 1) {
                        return (
                          <CgnBadge
                            color="danger"
                            className="w-100"
                            text={"Bekliyor"}
                          />
                        );
                      } else if (row.processStatus === 2) {
                        return (
                          <CgnBadge
                            color="warning"
                            className="w-100"
                            text={"Kargolandı"}
                          />
                        );
                      } else if (row.processStatus === 3) {
                        return (
                          <CgnBadge
                            color="info"
                            className="w-100"
                            text={"Elden Teslim Edildi"}
                          />
                        );
                      } else if (row.processStatus === 4) {
                        return (
                          <CgnBadge
                            color="success"
                            className="w-100"
                            text={"Tamamlandı"}
                          />
                        );
                      }
                    },
                  },
                  {
                    selector: "status",
                    width: "110px",
                    padding: "0px",
                    sortable: false,
                    cell: (row) => {
                      if (row.transferStatus === 1) {
                        return <CgnBadge color="danger" text="Beklemede" />;
                      } else {
                        return <CgnBadge color="success " text="Aktarıldı" />;
                      }
                    },
                  },
                  {
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, cell) => (
                      <CgnButtonDropdown
                        label={"Yönet"}
                        className="mr-0"
                        color="primary"
                        items={[
                          {
                            text: CgnMessage.detailButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageDetailLink}/${row.guid}`,
                          },
                          {
                            text: row.transferStatus === 1 ? "Aktar" : "",
                            className: "dropDownBtn",
                            onClick: () => this.stockTransfer(row.guid),
                          },
                          {
                            text: row.transferStatus === 1 ? "Sil" : "",
                            className: "dropDownBtn",
                            onClick: () => this.handleDelete(row.guid),
                          },
                        ]}
                      />
                    ),
                  },
                ]}
                loading={this.state.isLoading}
              />
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default TransferStockGetList;
